export default __webpack_public_path__ + "static/media/mitosis-division.55445201.jpg";